import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../App';
import api from '../api';
import { rolde } from '../yetki';

export default function Kullanicilar() {
  const { kullanici: aktifKullanici } = useContext(AuthContext);
  const [liste, setListe] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [duzenleme, setDuzenleme] = useState(null);
  const [form, setForm] = useState({ kullanici_adi:'', sifre:'', ad_soyad:'', email:'', rol:'personel', aktif:true });
  const [hata, setHata] = useState('');

  useEffect(() => { yukle(); }, []);
  const yukle = () => api.get('/tanimlar/kullanicilar').then(r => setListe(r.data));

  const ac = (k) => { setDuzenleme(k); setForm(k ? { ad_soyad:k.ad_soyad, email:k.email||'', rol:k.rol, aktif:k.aktif, sifre:'' } : { kullanici_adi:'', sifre:'', ad_soyad:'', email:'', rol:'personel', aktif:true }); setHata(''); setModalAcik(true); };

  const kaydet = async (e) => {
    e.preventDefault(); setHata('');
    try {
      if (duzenleme) await api.put(`/tanimlar/kullanicilar/${duzenleme.id}`, form);
      else await api.post('/tanimlar/kullanicilar', form);
      yukle(); setModalAcik(false);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  if (!rolde(aktifKullanici, 'admin')) return <div className="alert alert-error">Bu sayfaya erişim yetkiniz yok.</div>;

  const ROL_ETIKET = { superadmin:'Süper Admin', admin:'Yönetici', mudur:'Müdür', personel:'Personel', zabita:'Zabıta' };
  const ROL_RENK = { superadmin:'#6a1b9a', admin:'#b71c1c', mudur:'#1565c0', personel:'#1b5e20', zabita:'#4a148c' };

  return (
    <div>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px'}}>
        <h2 style={{color:'#1a237e'}}>👥 Kullanıcı Yönetimi</h2>
        <button className="btn btn-primary" onClick={() => ac(null)}>➕ Yeni Kullanıcı</button>
      </div>
      <div className="card">
        <table>
          <thead><tr><th>#</th><th>Kullanıcı Adı</th><th>Ad Soyad</th><th>E-Posta</th><th>Rol</th><th>Durum</th><th>Son Giriş</th><th>İşlem</th></tr></thead>
          <tbody>
            {liste.map((k,i) => (
              <tr key={k.id}>
                <td style={{color:'#999', fontSize:'12px'}}>{i+1}</td>
                <td><strong>{k.kullanici_adi}</strong></td>
                <td>{k.ad_soyad}</td>
                <td style={{fontSize:'12px', color:'#666'}}>{k.email || '—'}</td>
                <td><span style={{fontSize:'11px', padding:'2px 8px', borderRadius:'10px', background:'#f5f5f5', color: ROL_RENK[k.rol] || '#333', fontWeight:'600'}}>{ROL_ETIKET[k.rol] || k.rol}</span></td>
                <td><span style={{color: k.aktif ? 'green' : 'red'}}>{k.aktif ? '✅ Aktif' : '❌ Pasif'}</span></td>
                <td style={{fontSize:'12px', color:'#888'}}>{k.son_giris ? new Date(k.son_giris).toLocaleString('tr-TR') : 'Hiç giriş yapmadı'}</td>
                <td><button className="btn btn-outline btn-xs" onClick={() => ac(k)}>Düzenle</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modalAcik && (
        <div className="modal-overlay">
          <div className="modal" style={{maxWidth:'450px'}}>
            <div className="modal-header">
              <span className="modal-title">{duzenleme ? 'Kullanıcı Düzenle' : 'Yeni Kullanıcı'}</span>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            {hata && <div className="alert alert-error">{hata}</div>}
            <form onSubmit={kaydet}>
              <div className="form-grid">
                {!duzenleme && <div className="form-group"><label>Kullanıcı Adı *</label><input value={form.kullanici_adi} onChange={e => setForm({...form, kullanici_adi: e.target.value})} required /></div>}
                {!duzenleme && <div className="form-group"><label>Şifre *</label><input type="password" value={form.sifre} onChange={e => setForm({...form, sifre: e.target.value})} required /></div>}
                <div className="form-group"><label>Ad Soyad *</label><input value={form.ad_soyad} onChange={e => setForm({...form, ad_soyad: e.target.value})} required /></div>
                <div className="form-group"><label>E-Posta</label><input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
                <div className="form-group">
                  <label>Rol *</label>
                  <select value={form.rol} onChange={e => setForm({...form, rol: e.target.value})}>
                    <option value="personel">Personel</option>
                    <option value="zabita">Zabıta</option>
                    <option value="mudur">Müdür</option>
                    <option value="admin">Yönetici</option>
                    {aktifKullanici?.rol === 'superadmin' && <option value="superadmin">Süper Admin</option>}
                  </select>
                </div>
                {duzenleme && (
                  <div className="form-group">
                    <label>Durum</label>
                    <select value={form.aktif} onChange={e => setForm({...form, aktif: e.target.value === 'true'})}>
                      <option value="true">Aktif</option>
                      <option value="false">Pasif</option>
                    </select>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
